<template>
  <div class="content-item flex">
    <!-- <p>疾病标签</p> -->

    <div class="disease-tab-list flex">
      <span class="disease-tab disease-tab-add" @click="openDeseaseDialog"
        >添加疾病</span
      >
      <span
        class="disease-tab"
        v-for="(item, index) in diseaseLabels"
        :key="index"
      >
        {{ item.diseaseName }}
        <img src="~_img/off.png" alt="del" @click="delDisease(index)" />
      </span>
    </div>
    <!-- <el-dialog
        class="tips-dialog"
        title="为什么要打疾病标签"
        :show-close=false
        :visible.sync="deseaseTips"
        width="722px"
        center>
        <div>
          <p class="before-content-color title"><span class="before-icon"></span> 疾病标签说明</p>
          <p class="dialog-contents" >给文章打上相关的疾病，可以帮您更好的展示文章</p>
        </div>
        <div slot="footer" class="dialog-footer btns">
          <el-button type="primary" @click="deseaseTips=false" class="dialog-but">我知道了</el-button>
        </div>
      </el-dialog> -->
    <!-- <p>给文章打上相关的疾病，可以帮您更好的展示文章</p> -->
    <modal
      :isShow.sync="dialogDeseaseVisible"
      :title="dialogTitles"
      :btnText="btnText"
      :isShowBtn="isShowBtn"
      :width="dialogWidth"
      @clickHandler="clickHandler"
    >
      <div class="search-dialog-wrap">
        <el-input
          placeholder="请输入内容"
          v-model="searchDiseaseName"
          class="input-with-select"
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="queryDiseases"
            class="search-but"
            >搜索</el-button
          >
        </el-input>
        <div class="search-desease-body">
          <div class="search-data">
            <el-checkbox-group
              v-model="searchDiseaseChecked"
              v-if="searchDiseaseList.length && !isShowSearchNoData"
              @change="searchDiseaseChange"
            >
              <el-checkbox
                :label="item.diseaseId"
                v-for="(item, index) in searchDiseaseList"
                :key="index"
                >{{ item.diseaseName }}</el-checkbox
              >
            </el-checkbox-group>
          </div>
          <div
            class="noData flex flex-direction-column justify-content-center align-items-center"
            v-if="isShowSearchNoData"
          >
            <img src="~_img/search-noData.png" alt="没有数据" />
            <p class="errorInfo">很抱歉，暂未收录相关疾病</p>
          </div>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import { queryDiseases } from "@/api/user.js";
import modal from "@/components/modal";
export default {
  name: "diseaseLabel",
  props: ["data"],
  data() {
    return {
      deseaseTips: false,
      dialogDeseaseVisible: false, //添加疾病弹窗
      isShowSearchNoData: false,
      searchDiseaseName: "",
      searchDiseaseList: [],
      searchDiseaseListHistory: [],
      searchDiseaseChecked: [],
      diseaseLabels: [],
      dialogTitles: "搜索疾病",
      btnText: ["取消", "确认"],
      dialogWidth: "480px",
      isShowBtn: [true, true],
    };
  },
  components: {
    modal,
  },
  watch: {
    // diseaseLabels(val){
    // 	this.$emit('change-disease-labels',val)
    // },
    data(val) {
      console.log("!!!!!!DisLabeldata", val);
      this.searchDiseaseChecked = [];
      if (val) {
        for (let i = 0; i < val.length; i++) {
          this.searchDiseaseChecked.push(val[i].diseaseId);
        }
      }
      this.diseaseLabels = val;
      val.map((item) => {
        this.searchDiseaseListHistory.push(item);
      });
    },
  },
  created() {
    this.diseaseLabels = this.data;
  },
  methods: {
    clickHandler(val) {
      if (val == "one") {
        this.dialogDeseaseVisible = false;
      }
      if (val == "two") {
        this.addDesease();
        this.$emit("changeDiseaseLabels", this.diseaseLabels);
      }
    },
    //打开疾病标签弹窗
    openDeseaseDialog() {
      this.dialogDeseaseVisible = true;
      this.isShowSearchNoData = false;
      this.searchDiseaseList = [];
      this.searchDiseaseName = "";
    },
    // 获取选中的疾病标签
    searchDiseaseChange() {
      if (this.searchDiseaseChecked && this.searchDiseaseChecked.length > 3) {
        this.$message.error("疾病标签最多选3个~");
        this.searchDiseaseChecked.pop();
      }
    },
    getSearchDiseaseListData() {
      let array = this.searchDiseaseListHistory.filter((item) => {
        return this.searchDiseaseChecked.some((i) => {
          return i == item.diseaseId;
        });
      });
      let _map = [];
      return array.filter((item) => {
        if (!_map.includes(item.diseaseId)) {
          _map.push(item.diseaseId);
          return true;
        } else {
          return false;
        }
      });
    },
    //添加疾病
    addDesease() {
      if (this.searchDiseaseChecked.length > 3) {
        return;
      }
      let dataList = this.getSearchDiseaseListData();
      this.diseaseLabels = this.diseaseLabels || [];
      this.diseaseLabels.splice(0, this.diseaseLabels.length, ...dataList);
      this.dialogDeseaseVisible = false;
    },
    delDisease(index) {
      this.diseaseLabels.splice(index, 1);
      this.searchDiseaseChecked.splice(index, 1);
    },
    // 搜索疾病
    queryDiseases() {
      if (this.searchDiseaseName) {
        console.log("-------1");
        queryDiseases({
          tenantId: this.$commonJs.getTenantId(),
          diseaseName: this.searchDiseaseName,
        })
          .then((res) => {
            console.log("res---", res);
            if (res && res.data.length) {
              this.isShowSearchNoData = false;
              this.searchDiseaseList = res.data;
              res.data.map((item) => {
                this.searchDiseaseListHistory.push(item);
              });
            } else {
              this.isShowSearchNoData = true;
            }
          })
          .catch((err) => {
            this.isShowSearchNoData = true;
          });
      } else {
        this.isShowSearchNoData = true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/dialog_common.scss";
$color: #266cee;
.input-with-select {
  width: 437px !important;
  padding-bottom: 4px !important;
}
//疾病搜索
.search-dialog-wrap {
  min-height: 138px;
  margin: 20px;
  .search-data {
    max-height: 138px;
    overflow: hidden;
    overflow-y: auto;
    margin-top: 20px;
    &::-webkit-scrollbar {
      width: 4px;
    }
    &::-webkit-scrollbar-thumb {
      width: 4px;
      height: 30px;
      background-color: #989ca5;
    }
    .el-checkbox {
      margin-right: 24px;
    }
    .el-checkbox__label {
      color: #262626;
      padding-left: 6px;
    }
    .el-checkbox__input.is-checked .el-checkbox__inner,
    .el-checkbox__input.is-indeterminate .el-checkbox__inner {
      background: $color;
      border-color: $color;
    }
    .el-checkbox__input.is-checked + .el-checkbox__label {
      color: #262626;
    }
    .el-checkbox__inner:hover {
      border-color: $color;
    }
  }
  .noData {
    img {
      width: 121px;
      height: 78px;
      border: none;
    }
    p {
      font-size: 12px;
      color: #9a9a9a;
      margin-top: 20px;
    }
  }
}
.have {
  cursor: pointer;
}
.btns {
  padding-bottom: 22px;
  padding-top: 40px;
  line-height: 0px !important;
}
.dialog-but {
  padding-top: 9px;
}
:deep(.button) {
  line-height: 0px !important;
}
:deep(.el-button .el-button--primary) {
  padding-top: 10px;
}
.search-but {
  padding-top: 8px;
}
.errorInfo {
  width: 145px !important;
  text-align: right;
  margin-right: 10px;
}
.disease-tab {
  margin-top: 35px !important;
}
.disease-tab-list {
  position: relative !important;
}
.desease-tips {
  width: 147px !important;
  height: 20px;
  position: absolute;
  left: 878px;
  top: 0;
}
.disease-tab-add {
  width: 105px !important;
  position: absolute !important;
  left: 0px;
  top: -37px;
}
.disease-tab-list {
  .disease-tab {
    display: inline-block;
    height: 32px;
    line-height: 32px;
    text-align: center;
    // background: rgba(255, 110, 0, 0.12);
    border: 1px solid #0058ee;
    border-radius: 2px;
    padding: 0 16px;
    margin-right: 28px;
    cursor: pointer;
    // color: #FF6E00;
    color: #0058ee;
    position: relative;
    margin-bottom: 20px;
    img {
      position: absolute;
      top: -8px;
      right: -8px;
      width: 15px;
      height: 15px;
      background-size: 15px;
    }
  }
  .disease-tab-add {
    border: 1px dashed rgba(154, 154, 154, 1);
    background: rgba(255, 255, 255, 1);
    color: rgba(38, 38, 38, 1);
    &::before {
      content: "";
      display: inline-block;
      width: 12px;
      height: 12px;
      background: url("~_img/add.png") no-repeat;
      background-size: 12px;
    }
    &::after {
      display: none;
    }
  }
}
</style>
